import { Box, BoxProps, BadgeProps } from '@chakra-ui/react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

interface IconProps extends Omit<FontAwesomeIconProps, 'icon'> {}

interface IIcon extends BoxProps {
  icon: FontAwesomeIconProps['icon'];
  fixedWidth?: FontAwesomeIconProps['fixedWidth'];
  size?: FontAwesomeIconProps['size'];
  colorScheme?: BadgeProps['colorScheme'];
  iconProps?: IconProps;
}

const Icon = (props: IIcon) => {
  const { icon, fixedWidth, size, colorScheme = 'utility', iconProps } = props;

  const getColor = () => {
    if (colorScheme === 'utility') {
      return {
        color: 'utility.500',
        _dark: { color: 'whiteAlpha.600' }
      };
    } else {
      return {
        color: `${colorScheme}.500`,
        _dark: { color: `${colorScheme}.300` }
      };
    }
  };

  const colors = getColor();

  return (
    <Box as="span" {...colors} {...props}>
      <FontAwesomeIcon icon={icon} fixedWidth={fixedWidth} size={size} {...iconProps} />
    </Box>
  );
};

export { Icon };
